import { getAuthorizationHeader } from '../sgwt/sgwtConnect.ts'
import { type HealthDto } from '@/models/health.ts'
import { getConfig } from '@/config/config.ts';
import type { PingdomCreationDto } from '@/models/pingdom.ts';
import type { Statistic, StatisticsUptimeDistinctDto, StatisticsUptimeDto, StatisticsUptimesDto } from '@/models/statisticsUptime.ts';


export class StatisticsService {
  getAll(): Promise<StatisticsUptimeDto[]> {

    const { apiUrl } = getConfig();
    const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      } as RequestInit;

    return fetch(`${apiUrl}/api/v2/statistics/uptime`, requestOptions)
    .then((_response: Response) => {
        if( _response.ok)
        {
          try {
            return _response.json();
          }
          catch (error) {
              return { status: "Healthy"};
          }

        }
        else {
            throw new Error('An error occurs');
        }
    })
    .then((data: StatisticsUptimesDto) => {
      return data.statistics;
    })
    .catch((reason: any) => {
      if ((reason+"").indexOf("SyntaxError: Failed to execute 'json' on 'Response': Unexpected end of JSON input") >= 0)
        return { status: "Healthy" };
      throw reason;
    });
  }

  
  getAllDistinctUrls(): Promise<Statistic[]> {

    const { apiUrl } = getConfig();
    const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      } as RequestInit;

    return fetch(`${apiUrl}/api/v2/statistics`, requestOptions)
    .then((_response: Response) => {
        if( _response.ok)
        {
          try {
            return _response.json();
          }
          catch (error) {
              return { status: error};
          }

        }
        else {
            throw new Error('An error occurs');
        }
    })
    .then((data: StatisticsUptimesDto) => {
      return data.statistics;
    })
    .catch((reason: any) => {
      if ((reason+"").indexOf("SyntaxError: Failed to execute 'json' on 'Response': Unexpected end of JSON input") >= 0)
        return { status: "Healthy" };
      throw reason;
    });
  }
}